export default "__VITE_ASSET__aebddb63__"